import React from 'react';
import Styles from './EmprestimoGarantiaCarroContratoDA.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import { isMobile } from '@/utils/browser';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroContratoDA() {
  return (
    <section id="emp-garantia-contrato-d-a">
      <ContainerHome24>
        <div className="emp-garantia-contrato-d-a-titulos">
          <h2 className="emp-garantia-contrato-d-a-titulo">
            Vantagens do pagamento em débito automático
          </h2>
          <p className="emp-garantia-contrato-d-a-subtitulo">
            Você sabia que ao trocar seu pagamento de <b>boleto para débito automático</b>, você
            conta com diversas vantagens? <br />
            <br />
            Confira abaixo todos os benefícios de pagar suas parcelas do financiamento em débito
            automático:
          </p>
        </div>
        <div className="emp-garantia-contrato-d-a-cards">
          <CustomEmblaCarouselHome24
            // loop
            enableBullets
            enableMobileArrows
            // options={{ slidesToScroll: isMobile() ? 2 : 3 }}
            detectBulletCount
            // hideOverflow
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/ic_da_1.svg"
                    alt=""
                    className="card-img"
                  />
                  <p className="card-texto">
                    Ao utilizar o pagamento em débito automático, você ganha praticidade, evita
                    esquecimentos e mantém suas contas em dia.
                  </p>
                </div>
                <div className={`slide ${className}`}>
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/ic_da_2.svg"
                    alt=""
                    className="card-img"
                  />
                  <p className="card-texto">
                    O débito automático permite facilidade no momento do pagamento, já que não será
                    necessário gerar os boletos todos os meses.
                  </p>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
        <RedButton
          href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
          target="_blank"
          className="emp-garantia-contrato-d-a-btn"
        >
          Alterar forma de pagamento
        </RedButton>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default EmprestimoGarantiaCarroContratoDA;
